<div class="inner-page-header py-5 text-white">
  <div class="container px-lg-5">
    <h1 class="display-5 fw-bold text-uppercase mb-2">Seminars and Workshops</h1>
    <p class="lead mb-0 text-orange-light">“Knowledge Beyond the Classroom”</p>
  </div>
</div>

<div class="container px-lg-5 py-5">
  <div class="row g-5">
    <div class="col-12 col-lg-7">
      <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success mb-4">
        <h3 class="fw-bold mb-4 text-success border-bottom pb-2">
          <i class="fa-solid fa-chalkboard-user me-2"></i> Holistic Education
        </h3>
        
        <p class="lead text-muted mb-4" style="line-height: 1.8; text-align: justify;">
          At Shah Satnam Ji Girls’ College, Sirsa, we believe in holistic education that goes beyond textbooks. Our commitment to empowering students is reflected in the diverse range of seminars and workshops we organize throughout the academic year. These sessions are designed to enhance knowledge, develop essential skills, and create awareness of various important issues.
        </p>

        <h5 class="fw-bold text-success mb-3">Key Topics Covered</h5>
        <ul class="list-group list-group-flush mb-4">
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>Communication Skills</strong>: Effective Communication is key to success in all walks of life. Our workshops on communication skills help students improve their verbal and non-verbal communication, public speaking, and interpersonal skills.</div>
          </li>
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>Environment Pollution</strong>: Understanding the impact of Pollution is crucial for future generations. We host seminars that educate students about environmental issues, sustainable practices, and the importance of conservation.</div>
          </li>
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>Constitution Awareness</strong>: Knowledge of the Constitution is fundamental for every citizen. Our constitution awareness seminars enlighten students about their rights, duties, and the significance of the Indian Constitution in maintaining democracy and justice.</div>
          </li>
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>Computing Techniques</strong>: In the digital age, proficiency in computing is essential. Our workshops cover the latest computing techniques, software skills, and IT trends, preparing students for technology-driven careers.</div>
          </li>
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>AIDS Awareness</strong>: Raising awareness about AIDS is crucial for public health. Our seminars provide comprehensive information about HIV/AIDS, prevention methods, and the importance of compassion and support for affected individuals.</div>
          </li>
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>Gender Inequality</strong>: Promoting gender equality is at the heart of our mission. Workshops on gender inequality address issues of discrimination, gender roles, and empowerment, aiming to create a more just and equal society.</div>
          </li>
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>Awareness (Drug Abuse)</strong>: The dangers of drug abuse are a serious concern. Our drug awareness seminars educate students about the risks of drug use, prevention strategies, and ways to seek help for addiction.</div>
          </li>
        </ul>

        <p class="text-muted border-top pt-3 mb-0" style="line-height: 1.7; text-align: justify;">
          Each seminar and workshop is led by experts and professionals who bring in-depth knowledge and practical insights to the table. We aim to equip our students with the necessary tools to thrive in a rapidly changing world, making them responsible, informed, and proactive individuals. Join us at Shah Satnam Ji Girls’ College, Sirsa, where learning transcends the classroom, and every student is encouraged to grow into a well-rounded individual ready to face the challenges of tomorrow.
        </p>
      </div>
    </div>

    <!-- Right Side Reports Card -->
    <div class="col-12 col-lg-5">
      <div class="sidebar-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-orange mb-4">
        <h4 class="fw-bold mb-4 text-orange-dark border-bottom pb-2">
          <i class="fa-solid fa-file-pdf me-2"></i> Seminar Reports
        </h4>
        
        <!-- Year Selection Tabs -->
        <ul class="nav nav-pills mb-4 gap-2" id="seminarTabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link py-2 px-3 fw-bold rounded-3" [class.active]="selectedYear === '2023-24'" (click)="selectedYear = '2023-24'">2023-24</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link py-2 px-3 fw-bold rounded-3" [class.active]="selectedYear === '2022-23'" (click)="selectedYear = '2022-23'">2022-23</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link py-2 px-3 fw-bold rounded-3" [class.active]="selectedYear === '2021-22'" (click)="selectedYear = '2021-22'">2021-22</button>
          </li>
        </ul>

        <!-- Custom PDF Display Box -->
        <div class="pdf-wrapper shadow-sm border rounded-4 overflow-hidden mb-4 bg-light position-relative">
          <div class="pdf-overlay-action p-3 d-flex align-items-center justify-content-between text-white" style="background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);">
            <span class="fw-bold small"><i class="fa-solid fa-eye me-1"></i> Seminar Plan ({{ selectedYear }})</span>
            <a [href]="getPdfPath()" download class="btn btn-sm btn-warning text-dark fw-bold border-0"><i class="fa-solid fa-download me-1"></i> Download</a>
          </div>
          <div class="pdf-container-view" style="height: 380px; overflow-y: auto;">
            <pdf-viewer [src]="getPdfPath()" [render-text]="true" [original-size]="false" style="width: 100%; height: 100%; display: block;"></pdf-viewer>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Gallery Section -->
  <h3 class="fw-bold text-success mt-5 mb-4 text-uppercase border-bottom pb-2">
    <i class="fa-solid fa-images me-2"></i> Seminars & Workshops Gallery
  </h3>

  <div class="row g-3 mb-4">
    <div class="col-6 col-md-3" *ngFor="let img of seminarImages">
      <div class="rounded-4 overflow-hidden shadow-sm border border-2 border-white">
        <img [src]="img" alt="Seminar & Workshop" class="img-fluid w-100" style="object-fit: cover; height: 200px;">
      </div>
    </div>
  </div>
</div>
